import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    lockSignup: null,
    siteUnderMaintenance: null,
    appVersion: "",
    changeSidebar: null
};

export const managementSlice = createSlice({
    name: 'management',
    initialState,
    reducers: {
        storeManagement: (state, action) => {
            state.lockSignup = action.payload.lockSignup;
            state.siteUnderMaintenance = action.payload.siteUnderMaintenance;
            state.appVersion = action.payload.appVersion;
        },
        storeChangeSidebar: (state, action) => {
            state.changeSidebar = action.payload.changeSidebar
        },
        resetManagement: state => initialState
    }
});

export const {storeManagement, storeChangeSidebar, resetManagement} = managementSlice.actions;

export const selectLockSignup = state => state.management.lockSignup;
export const selectSiteUnderMaintenance = state => state.management.siteUnderMaintenance;
export const selectAppVersion = state => state.management.appVersion;
export const selectChangeSidebar = state => state.management.changeSidebar;

export default managementSlice.reducer;
